var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Component } from 'vue-property-decorator';
import AidApplicationBase from '@/template/views/AidApplicationBase';
import TextAreaRow from '@/common/components/TextAreaRow.vue';
import RadioButtonRow from '@/common/components/RadioButtonRow.vue';
import CheckBoxListRow from '@/common/components/CheckBoxListRow.vue';
import DateInputRow from '@/common/components/DateInputRow.vue';
import LocationControl from '@/template/components/shared/LocationControl.vue';
import OtherOperationControl from '@/template/components/aidApplication/controls/OtherOperationControl.vue';
import PlaceOpenBasicInfoView from '@/template/components/aidApplication/placeOpen/BasicInfoView.vue';
import InvestmentBasicInfoView from '@/template/components/aidApplication/investment/BasicInfoView.vue';
import { parseString, absoluteMinimumDate, absoluteMaximumDate, reasonableMinimumDate, reasonableMaximumDate } from '@/common/utils/dateUtilities';
var BasicInfoView = /** @class */ (function (_super) {
    __extends(BasicInfoView, _super);
    function BasicInfoView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BasicInfoView.prototype.created = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, Promise.all([
                            this.initMunicipalities(),
                            this.initRegions()
                        ])];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(BasicInfoView.prototype, "startTimeRules", {
        get: function () {
            var minDate = parseString(this.isExtension
                ? absoluteMinimumDate
                : reasonableMinimumDate(this.aidapplication.applicationYear));
            var maxDate = parseString(reasonableMaximumDate(this.aidapplication.applicationYear));
            return {
                // Ay applications do not have EndTime field
                earlierStr: !this.isAy ? '@AidApplication.BasicInfo.EndTime' : false,
                within: [minDate, maxDate]
            };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicInfoView.prototype, "endTimeRules", {
        get: function () {
            var maxDate = parseString(absoluteMaximumDate);
            return {
                laterStr: '@AidApplication.BasicInfo.StartTime',
                within: [null, maxDate]
            };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicInfoView.prototype, "startTimeRequired", {
        get: function () {
            return this.isC || this.isB || !this.isExtension;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicInfoView.prototype, "endTimeRequired", {
        get: function () {
            return this.isC || this.isB;
        },
        enumerable: false,
        configurable: true
    });
    BasicInfoView = __decorate([
        Component({
            name: "BasicInfoView",
            components: {
                RadioButtonRow: RadioButtonRow,
                CheckBoxListRow: CheckBoxListRow,
                TextAreaRow: TextAreaRow,
                DateInputRow: DateInputRow,
                LocationControl: LocationControl,
                OtherOperationControl: OtherOperationControl,
                PlaceOpenBasicInfoView: PlaceOpenBasicInfoView,
                InvestmentBasicInfoView: InvestmentBasicInfoView
            }
        })
    ], BasicInfoView);
    return BasicInfoView;
}(AidApplicationBase));
export default BasicInfoView;
